import { render, staticRenderFns } from "./YyjZsxxData.vue?vue&type=template&id=4eac2d04&scoped=true&"
import script from "./YyjZsxxData.vue?vue&type=script&lang=js&"
export * from "./YyjZsxxData.vue?vue&type=script&lang=js&"
import style0 from "./YyjZsxxData.vue?vue&type=style&index=0&id=4eac2d04&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eac2d04",
  null
  
)

export default component.exports